// removed by extract-text-webpack-plugin
module.exports = {"toolbar":"toolbar__29__L","collapsed":"collapsed__3pJZC","tools":"tools__2P7fO","toggle":"toggle__1vjC0","arrow":"arrow__1BxBw","pullRight":"pullRight__3EEP0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PanelToolbar/styles.scss
// module id = 2140
// module chunks = 1